module.exports = __webpack_public_path__ + "assets/chevron-right-small.2665418f.svg";